import * as React from "react";
import "@styles/synchrony-buttons-selectors-theme.scss";

interface SwitchButtonProps {
  inputValue?: string | number;
  checked?: boolean;
  className?: string;
  labelID?: string;
  containerStyle?: string;
  buttonBarContainerStyle?: string;
  buttonStyle?: string;
  labelStyle?: string;
  buttonBarStyle?: string;
  label?: string;
  disabled?: boolean;
  onClickCallback?: (value: string | number | undefined, checked: boolean) => void;
}

const SwitchButton: React.FC<SwitchButtonProps> = ({
  inputValue,
  checked,
  className,
  labelID,
  containerStyle = "",
  buttonBarContainerStyle = "",
  buttonStyle = "",
  labelStyle = "",
  buttonBarStyle = "",
  label,
  disabled = false,
  onClickCallback,
}) => {
  return (
    <div
      className={`w-max p-3 flex items-center justify-center ${className} ${disabled ? "cursor-auto opacity-50" : "cursor-pointer opacity-100"
        } ${containerStyle}`}
      onClick={() => (!disabled && onClickCallback ? onClickCallback(inputValue, !checked) : null)}
    >
      <div
        className={`w-10 h-5 relative mr-3.75 flex-col  flex items-center justify-center ${buttonBarContainerStyle}`}
      >
        <div
          id="switch-bar"
          className={`absolute opacity-40 rounded-lg-2 w-49/50 h-3.5 ${disabled || !checked ? "bg-color-steel-gray" : "bg-color-dark-green"
            } ${buttonBarStyle}`}
        ></div>
        <div
          id="switch-button"
          className={`w-5 h-5 absolute rounded-1/2 self-start shadow-sm2 duration-300 ease-in-out transition-all ${checked ? "translate-x-full" : "translate-x-0"
            } ${disabled
              ? "bg-color-steel-gray"
              : checked
                ? "bg-color-dark-green"
                : "bg-white"
            } ${buttonStyle}`}
        ></div>
      </div>
      <div id={labelID} className={labelStyle}>
        {label}
      </div>
    </div>
  );
};

export default SwitchButton;
